<span class="pop-tag">
  <mat-icon> {{ getIcon() }}</mat-icon>
</span>
